import { SectionMarks } from './sections.model';

export class SectionService {
	kindSet: { value: string; name: string }[] = [
		{ value: SectionMarks.HIGHLITED, name: 'Wyróżniona' },
		{ value: SectionMarks.BASIC, name: 'Podstawowa' },
		{ value: SectionMarks.LIST, name: 'Lista' },
		{ value: SectionMarks.HORIZONTAL, name: 'Lista horyzontalna' },
	];
}
